<template>
  <g>
    <g style="transform:scale(0.6)">
        <text transform="matrix(1 0 0 1 70 60)" class="name">가속도센서{{number}}</text>
        <path class="st0" d="M67,354.5v-286h233v286H67z M259,289.5c-11.03,0-20,8.97-20,20s8.97,20,20,20s20-8.97,20-20
            S270.03,289.5,259,289.5z M259,95.5c-11.03,0-20,8.97-20,20s8.97,20,20,20s20-8.97,20-20S270.03,95.5,259,95.5z"/>
        <path class="st1" d="M70,71.5v280h227v-280H70z M259,332.5c-12.7,0-23-10.3-23-23c0-12.7,10.3-23,23-23s23,10.3,23,23
            C282,322.2,271.7,332.5,259,332.5z M259,138.5c-12.7,0-23-10.3-23-23c0-12.7,10.3-23,23-23s23,10.3,23,23
            C282,128.2,271.7,138.5,259,138.5z"/>
        <g style="transform:translate(0,-1px)">
            <g class="pin">
                <rect x="83" y="93.62" class="st2" width="18" height="18"/>
                <path class="st3" d="M103,113.62H81v-22h22V113.62z M85,109.62h14v-14H85V109.62z"/>
                <rect :id="`${pindcode}PS`" @click="onClick(`${pindcode}PS`)" x="81" y="91" class="pin-cover terminal" width="20" height="20"/>
            </g>
            <text transform="matrix(1 0 0 1 109.1194 108.6046)" class="st4 st5 st6">VCC</text>
        </g>
        <g  style="transform:translate(0,-3px)">
            <g class="pin">
                <rect x="83" y="124.97" class="st2" width="18" height="18"/>
                <path class="st3" d="M103,144.97H81v-22h22V144.97z M85,140.97h14v-14H85V140.97z"/>
                <rect :id="`${pindcode}MS`" @click="onClick(`${pindcode}MS`)" x="81" y="122" class="pin-cover terminal" width="20" height="20"/>
            </g>
            <text transform="matrix(1 0 0 1 109.1194 140.1051)" class="st4 st5 st6">GND</text>
        </g>
        <g style="transform:translate(0,-3px)">
            <g class="pin">
                <rect x="83" y="156.33" class="st2" width="18" height="18"/>
                <path class="st3" d="M103,176.33H81v-22h22V176.33z M85,172.33h14v-14H85V172.33z"/>
                <rect :id="`${pindcode}CL`" @click="onClick(`${pindcode}CL`)" x="81" y="154" class="pin-cover terminal" width="20" height="20"/>
            </g>
            <text transform="matrix(1 0 0 1 109.1194 171.6058)" class="st4 st5 st6">SCL</text>
        </g>
        <g style="transform:translate(0,-4px)">
            <g class="pin">
                <rect x="83" y="187.69" class="st2" width="18" height="18"/>
                <path class="st3" d="M103,207.69H81v-22h22V207.69z M85,203.69h14v-14H85V203.69z"/>
                <rect :id="`${pindcode}DA`" @click="onClick(`${pindcode}DA`)" x="81" y="185" class="pin-cover terminal" width="20" height="20"/>
            </g>
            <text transform="matrix(1 0 0 1 109.1189 203.1066)" class="st4 st5 st6">SDA</text>
        </g>
        <g style="transform:translate(0,-5px)">
            <g class="disable">
                <rect x="83" y="219.05" class="st2" width="18" height="18"/>
                <path class="st3" d="M103,239.05H81v-22h22V239.05z M85,235.05h14v-14H85V235.05z"/>
                <rect x="81" y="217" class="pin-cover terminal" width="20" height="20"/>
            </g>
            <text transform="matrix(1 0 0 1 109.1189 234.6071)" class="st4 st5 st6">XDA</text>
        </g>
        <g style="transform:translate(0,-6px)">
            <g class="disable">
                <rect x="83" y="250.4" class="st2" width="18" height="18"/>
                <path class="st3" d="M103,270.4H81v-22h22V270.4z M85,266.4h14v-14H85V266.4z"/>
                <rect x="81" y="248" class="pin-cover terminal" width="20" height="20"/>
            </g>
            <text transform="matrix(1 0 0 1 109.1189 266.1078)" class="st4 st5 st6">XCL</text>
        </g>
        <g style="transform:translate(0,-7px)">
            <g class="disable">
                <rect x="83" y="281.71" class="st2" width="18" height="18"/>
                <path class="st3" d="M103,301.71H81v-22h22V301.71z M85,297.71h14v-14H85V297.71z"/>
                <rect x="81" y="279" class="pin-cover terminal" width="20" height="20"/>
            </g>
            <text transform="matrix(1 0 0 1 109.1194 297.5602)" class="st4 st5 st6">ADO</text>
        </g>
        <g style="transform:translate(0,-8px)">
            <g class="pin">
                <rect x="83" y="313" class="st2" width="18" height="18"/>
                <path class="st3" d="M103,333H81v-22h22V333z M85,329h14v-14H85V329z"/>
                <rect :id="`${pindcode}IN`" @click="onClick(`${pindcode}IN`)" x="81" y="311" class="pin-cover terminal" width="20" height="20"/>
            </g>
            <text transform="matrix(1 0 0 1 109.1189 328.9895)" class="st4 st5 st6">INT</text>
        </g>
        <g style="transform:translate(0,-3px)">
            <rect x="256.17" y="218" class="st7" width="21" height="11"/>
            <rect x="256.17" y="166" class="st7" width="21" height="11"/>
            <g>
                <rect x="251.67" y="171.5" class="st8" width="30" height="39"/>
                <rect x="251.67" y="209.2" class="st9" width="30" height="14.3"/>
            </g>
        </g>
        <g>
            <g>
                <rect x="216" y="156" class="st7" width="5" height="4"/>
                <rect x="215" y="160" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="205.4" y="156" class="st7" width="5" height="4"/>
                <rect x="204.4" y="160" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="194.8" y="156" class="st7" width="5" height="4"/>
                <rect x="193.8" y="160" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="184.2" y="156" class="st7" width="5" height="4"/>
                <rect x="183.2" y="160" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="173.6" y="156" class="st7" width="5" height="4"/>
                <rect x="172.6" y="160" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="163" y="156" class="st7" width="5" height="4"/>
                <rect x="162" y="160" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="216" y="235" class="st7" width="5" height="4"/>
                <rect x="215" y="232" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="205.4" y="235" class="st7" width="5" height="4"/>
                <rect x="204.4" y="232" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="194.8" y="235" class="st7" width="5" height="4"/>
                <rect x="193.8" y="232" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="184.2" y="235" class="st7" width="5" height="4"/>
                <rect x="183.2" y="232" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="173.6" y="235" class="st7" width="5" height="4"/>
                <rect x="172.6" y="232" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="163" y="235" class="st7" width="5" height="4"/>
                <rect x="162" y="232" class="st10" width="7" height="3"/>
            </g>
            <g>
                <rect x="150" y="168.5" class="st7" width="4" height="5"/>
                <rect x="154" y="167.5" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="150" y="179.1" class="st7" width="4" height="5"/>
                <rect x="154" y="178.1" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="150" y="189.7" class="st7" width="4" height="5"/>
                <rect x="154" y="188.7" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="150" y="200.3" class="st7" width="4" height="5"/>
                <rect x="154" y="199.3" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="150" y="210.9" class="st7" width="4" height="5"/>
                <rect x="154" y="209.9" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="150" y="221.5" class="st7" width="4" height="5"/>
                <rect x="154" y="220.5" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="229" y="168.5" class="st7" width="4" height="5"/>
                <rect x="226" y="167.5" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="229" y="179.1" class="st7" width="4" height="5"/>
                <rect x="226" y="178.1" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="229" y="189.7" class="st7" width="4" height="5"/>
                <rect x="226" y="188.7" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="229" y="200.3" class="st7" width="4" height="5"/>
                <rect x="226" y="199.3" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="229" y="210.9" class="st7" width="4" height="5"/>
                <rect x="226" y="209.9" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="229" y="221.5" class="st7" width="4" height="5"/>
                <rect x="226" y="220.5" class="st10" width="3" height="7"/>
            </g>
            <rect x="157" y="163" class="st11" width="69" height="69"/>
        </g>
        <g>
            <g>
                <rect x="156" y="99.5" class="st7" width="4" height="5"/>
                <rect x="160" y="98.5" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="156" y="110.1" class="st7" width="4" height="5"/>
                <rect x="160" y="109.1" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="156" y="120.7" class="st7" width="4" height="5"/>
                <rect x="160" y="119.7" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="188" y="99.5" class="st7" width="4" height="5"/>
                <rect x="185" y="98.5" class="st10" width="3" height="7"/>
            </g>
            <g>
                <rect x="188" y="120.7" class="st7" width="4" height="5"/>
                <rect x="185" y="119.7" class="st10" width="3" height="7"/>
            </g>
            <rect x="163" y="94" class="st11" width="22" height="39"/>
        </g>
        <g>
            <g>
                <path class="st4" d="M203.48,307.02c0-0.1,0-0.21-0.01-0.31c0-0.02-0.01-0.05-0.02-0.07c-0.06-0.31-0.17-0.6-0.36-0.86l-6.5-8.5
                    c-0.67-0.88-1.93-1.04-2.8-0.37c-0.88,0.67-1.04,1.93-0.37,2.8l4.04,5.29H157.5c-1.1,0-2,0.9-2,2c0,0.01,0,0.02,0,0.02
                    c0,0.01,0,0.02,0,0.02c0,1.1,0.9,2,2,2h39.95l-4.04,5.29c-0.67,0.88-0.5,2.13,0.37,2.8c0.36,0.28,0.79,0.41,1.21,0.41
                    c0.6,0,1.2-0.27,1.59-0.79l6.5-8.5c0.2-0.26,0.31-0.55,0.36-0.86c0-0.02,0.01-0.05,0.02-0.07
                    C203.48,307.23,203.48,307.13,203.48,307.02z"/>
            </g>
            <g>
                <path class="st4" d="M188.7,319.95l-2.62-8.3c-0.32-1.06-1.44-1.65-2.5-1.33c-1.06,0.32-1.65,1.44-1.33,2.5l1.36,4.19
                    c-0.04,0-0.07-0.01-0.11-0.01c-5.24,0-9.5-4.26-9.5-9.5s4.26-9.5,9.5-9.5c1.1,0,2-0.9,2-2s-0.9-2-2-2c-7.44,0-13.5,6.06-13.5,13.5
                    c0,7.04,5.43,12.84,12.32,13.44l-0.04,0.1l-3.95,2.07c-0.93,0.59-1.22,1.82-0.63,2.76c0.24,0.39,0.6,0.66,0.99,0.81
                    c0.56,0.21,1.22,0.16,1.76-0.18l7.37-4.23c0.27-0.17,0.48-0.41,0.64-0.68c0.01-0.02,0.03-0.04,0.04-0.06
                    c0.05-0.09,0.08-0.19,0.12-0.28c0.04-0.1,0.07-0.19,0.1-0.29c0-0.02,0.01-0.05,0.01-0.07
                    C188.79,320.58,188.79,320.26,188.7,319.95z"/>
            </g>
            <g>
                <path class="st4" d="M221.86,325.49c0.36,0.58,0.45,1.08,0.27,1.5c-0.18,0.42-0.47,0.76-0.87,1.02c-0.4,0.26-0.86,0.34-1.37,0.25
                    s-0.92-0.35-1.21-0.79l-3.21-4.89l-3.18,4.89c-0.3,0.44-0.71,0.71-1.21,0.79s-0.96,0.01-1.37-0.25c-0.4-0.26-0.69-0.6-0.87-1.02
                    c-0.18-0.42-0.09-0.92,0.27-1.5l4.14-6.33l-4.23-6.48c-0.34-0.54-0.42-1.03-0.24-1.47c0.18-0.44,0.46-0.79,0.84-1.06
                    s0.83-0.35,1.35-0.25c0.52,0.1,0.95,0.4,1.29,0.9l3.21,4.95l3.24-4.95c0.34-0.5,0.77-0.8,1.29-0.9c0.52-0.1,0.97-0.02,1.35,0.25
                    c0.38,0.27,0.66,0.63,0.84,1.06c0.18,0.44,0.1,0.93-0.24,1.47l-4.23,6.48L221.86,325.49z"/>
            </g>
        </g>
        <g>
            <g>
                <path class="st4" d="M223.11,246.41c-0.1,0-0.21,0-0.31,0.01c-0.02,0-0.05,0.01-0.07,0.02c-0.31,0.06-0.6,0.17-0.86,0.36l-8.5,6.5
                    c-0.88,0.67-1.04,1.93-0.37,2.8c0.67,0.88,1.93,1.04,2.8,0.37l5.29-4.04v39.95c0,1.1,0.9,2,2,2c0.01,0,0.02,0,0.02,0
                    c0.01,0,0.02,0,0.02,0c1.1,0,2-0.9,2-2v-39.95l5.29,4.04c0.88,0.67,2.13,0.5,2.8-0.37c0.28-0.36,0.41-0.79,0.41-1.21
                    c0-0.6-0.27-1.2-0.79-1.59l-8.5-6.5c-0.26-0.2-0.55-0.31-0.86-0.36c-0.02,0-0.05-0.01-0.07-0.02
                    C223.32,246.41,223.21,246.41,223.11,246.41z"/>
            </g>
            <g>
                <path class="st4" d="M236.04,261.2l-8.3,2.62c-1.06,0.32-1.65,1.44-1.33,2.5c0.32,1.06,1.44,1.65,2.5,1.33l4.19-1.36
                    c0,0.04-0.01,0.07-0.01,0.11c0,5.24-4.26,9.5-9.5,9.5s-9.5-4.26-9.5-9.5c0-1.1-0.9-2-2-2s-2,0.9-2,2c0,7.44,6.06,13.5,13.5,13.5
                    c7.04,0,12.84-5.43,13.44-12.32l0.1,0.04l2.07,3.95c0.59,0.93,1.82,1.22,2.76,0.63c0.39-0.24,0.66-0.6,0.81-0.99
                    c0.21-0.56,0.16-1.22-0.18-1.76l-4.23-7.37c-0.17-0.27-0.41-0.48-0.68-0.64c-0.02-0.01-0.04-0.03-0.06-0.04
                    c-0.09-0.05-0.19-0.08-0.28-0.12c-0.1-0.04-0.19-0.07-0.29-0.1c-0.02,0-0.05-0.01-0.07-0.01
                    C236.66,261.1,236.35,261.1,236.04,261.2z"/>
            </g>
            <g>
                <path class="st4" d="M255.97,246.68l-5.22,8.19v5.88c0,0.66-0.31,1.13-0.93,1.4s-1.25,0.27-1.88,0s-0.95-0.73-0.95-1.4v-5.88
                    l-5.22-8.16c-0.34-0.56-0.41-1.05-0.21-1.48c0.2-0.43,0.5-0.77,0.9-1.04c0.4-0.26,0.85-0.33,1.36-0.22
                    c0.51,0.11,0.92,0.42,1.22,0.94l3.84,6.21l3.81-6.21c0.3-0.52,0.71-0.83,1.21-0.94c0.51-0.11,0.96-0.03,1.37,0.22
                    c0.4,0.26,0.7,0.61,0.9,1.04C256.38,245.66,256.31,246.14,255.97,246.68z"/>
            </g>
        </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Accelerator',
  data () {
    return {
      socket: null,
      on: false
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    start (socket) {
      this.socket = socket
      this.on = true
      // store.commit('msimul/setAccelerator', { on: this.on, socket, x: 0, y: 0 })
    },
    off () {
      this.socket = null
      this.on = false
      // store.commit('msimul/setAccelerator', { on: this.on, socket: null, x: 0, y: 0 })
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover{
  display: block;
  stroke: none;
  fill: none;
}
.pin:hover{
  cursor: pointer;
  .pin-cover{
    stroke-width: 5px;
    stroke: black;
    fill: #ff6f61;
 }
}
.selected{
  & path.st0{
    fill: #ff6f61;
    display: block;
  }
}
.disable:hover{
    cursor: not-allowed;
}
.name{font-size: 25px}
.st0{fill:#D6D6D6; display: none;}
.st1{fill:#3074A1;}
.st2{fill:#98643D;}
.st3{fill:#FBFECF;}
.st4{fill:#FFFFFF;}
.st5{font-family:'MyriadPro-Regular';}
.st6{font-size:17px; font-weight: bold;}
.st7{fill:#E0E3DD;}
.st8{fill:#E5C77A;}
.st9{fill:#D59D57;}
.st10{fill:#83746F;}
.st11{fill:#333333;}
</style>
